import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export type StatusTone = "neutral" | "success" | "warning" | "danger" | "info";

export interface StatusChipProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  tone?: StatusTone;
}

/** Status chip with text + non-color indicator (dot). */
export function StatusChip({
  children,
  className,
  tone = "neutral",
  ...rest
}: StatusChipProps) {
  return (
    <span className={cn(styles.statusChip, className)} {...rest}>
      <span
        className={cn(
          styles.statusDot,
          tone === "success" && styles.statusDotSuccess,
          tone === "warning" && styles.statusDotWarning,
          tone === "danger" && styles.statusDotDanger,
          tone === "info" && styles.statusDotInfo,
        )}
        aria-hidden
      />
      <span>{children}</span>
    </span>
  );
}
